import React, { createContext, ReactNode, useState } from 'react';
import MultiActions from './MultiActions';

interface Item {
  id: string | number;
  type: string;
}

export type MultiSelectionActionApi = {
  clearSelection: () => void;
};

export interface MultiSelectionContextType {
  isEnabled: boolean;
  selectedItems: Item[];
  updateSelectedItems: (items: Item[]) => void;
  clearSelection: () => void;
}

const defaultContextValue = {
  isEnabled: false,
  selectedItems: [],
  updateSelectedItems: () => {},
  clearSelection: () => {},
};

export const MultiSelectionContext =
  createContext<MultiSelectionContextType>(defaultContextValue);

type Action = {
  label: string;
  icon: React.ReactNode;
  action(selection: Item[]): void;
};

// Provider component
interface MultiSelectionProviderProps {
  children: ReactNode;
  actions?: (Action | null)[];
  getActions?: (api: MultiSelectionActionApi) => (Action | null)[];
}

const MultiSelectionProvider: React.FC<MultiSelectionProviderProps> = ({
  children,
  actions: actionsProp = [],
  getActions,
}) => {
  const [selectedItems, setSelectedItems] = useState<Item[]>([]);

  const updateSelectedItems = (items: Item[]) => {
    setSelectedItems(items);
  };

  const clearSelection = () => {
    setSelectedItems([]);
  };

  const actions = getActions ? getActions({ clearSelection }) : actionsProp;

  return (
    <MultiSelectionContext.Provider
      value={{
        selectedItems,
        updateSelectedItems,
        clearSelection,
        isEnabled: actions?.length > 0,
      }}
    >
      {children}
      <MultiActions
        actions={actions.filter((item) => item !== null)}
        items={selectedItems}
        isOpen={selectedItems.length > 0}
      />
    </MultiSelectionContext.Provider>
  );
};

export default MultiSelectionProvider;
